<template>
  <div class="person">
    <div
      class="pic mx-auto wow pulse"
      data-wow-duration="0.5s"
      data-wow-delay="0.2s"
    >
      <div
        class="bg-image"
        :style="{ backgroundImage: 'url(' + cover + ')' }"
      ></div>
    </div>
    <div
      class="name"
      v-html="name"
    >
    </div>
    <div
      class="title"
      v-for="(item, index) in title"
      :key="index"
      v-html="item"
    >
    </div>
  </div>
</template>


<script>
  export default {
    name: "Person",
    props: ["index", "cover", "name", "title"]
  };
</script>